import { clsx } from "clsx";
import styles from "./detectionBadge.module.scss";
import Typography from "../typography/Typography";

type DetectionBadgeProps = {
  detection: string;
  className?: string;
};

const DetectionBadge = ({ detection, className }: DetectionBadgeProps) => {
  const variant = detection.toLowerCase();
  return (
    <Typography
      variant="body4"
      tag="span"
      className={clsx(
        styles.detectionBadge,
        styles[variant],
        "text-center",
        "text-capitalize",
        className
      )}
    >
      {detection}
    </Typography>
  );
};

export default DetectionBadge;
